<template>
  <div>
    <div class="u-shadow-bottom bgc-white bdrs10 p20 mt25" v-if="analysis.genstatus !== 'generated' && analysis.genstatus !== 'failed'">
      <div class="fw-b ta-c mb15">企業研究を生成中です…<br>所要時間：約2〜3分</div>
      <div class="u-skelton-line"></div>
      <div class="u-skelton-line mt10"></div>
      <div class="u-skelton-line mt10" style="width: 80%;"></div>
    </div>
    <Section
      v-for="(content_html, index) in analysis.text_sections"
      :key="index"
      :prop-content-html="content_html"
      v-if="analysis.genstatus === 'generated'"
    />
  </div>
</template>

<script>
import { popupSuccess, popupError } from '@/packs/person/popup';
import Section from './PersonAiCompanyAnalysisResult/Section.vue';

const INITIAL_POLL_MS = 3000;
const MAX_POLL_MS = 30000;
const POLL_TIMEOUT_MS = 10 * 60 * 1000;

export default {
  components: { Section },
  props: {
    propAnalysis: Object,
    propCode: String,
    propStatusPath: String,
  },
  data() {
    return {
      analysis: {},
      text: '',
      pollTimer: null,
      pollInterval: INITIAL_POLL_MS,
      pollStartedAt: null,
    }
  },
  created() {
    this.analysis = this.propAnalysis;
    this.boot();
  },
  beforeDestroy() {
    this.clearPoll();
  },
  methods: {
    boot() {
      if (this.isFinalStatus(this.analysis.genstatus)) return;

      // 作成・再生成時にサーバ側で queued になっているため、
      // 本コンポーネントは状態をポーリングして表示を切り替えるだけで良い。
      this.startPolling();
    },

    isFinalStatus(status) {
      return status === 'generated' || status === 'failed';
    },

    startPolling() {
      if (this.pollTimer) return;
      this.pollInterval = INITIAL_POLL_MS;
      this.pollStartedAt = Date.now();
      this.schedulePoll();
      this.fetchStatus();
    },

    schedulePoll() {
      this.pollTimer = setTimeout(() => {
        if (Date.now() - this.pollStartedAt >= POLL_TIMEOUT_MS) {
          this.clearPoll();
          popupError('生成に時間がかかっています。ページを再読み込みしてください。');
          return;
        }
        this.fetchStatus();
        this.pollInterval = Math.min(this.pollInterval * 2, MAX_POLL_MS);
        this.schedulePoll();
      }, this.pollInterval);
    },

    clearPoll() {
      if (this.pollTimer) {
        clearTimeout(this.pollTimer);
        this.pollTimer = null;
      }
    },

    async fetchStatus() {
      try {
        const res = await fetch(this.propStatusPath, {
          headers: { Accept: 'application/json' },
        });

        if (!res.ok) {
          this.clearPoll();
          popupError('生成に失敗しました。この企業研究は削除された可能性があります。');
          return;
        }

        const data = await res.json();
        const prev = this.analysis.genstatus;
        this.analysis = { ...this.analysis, ...data.analysis };

        if (this.analysis.genstatus === 'generated') {
          this.clearPoll();
          if (prev !== 'generated') {
            popupSuccess('生成しました!');
          }
        }

        if (this.analysis.genstatus === 'failed') {
          this.clearPoll();
          popupError('生成に失敗しました。');
        }
      } catch (_e) {
        this.clearPoll();
        popupError('状態の取得に失敗しました。');
      }
    },
  },
}
</script>
